@let atelier = atelier$ | async;
@let evenements = evenements$ | async;


@if(atelier){
<h1 class="title">{{atelier.titre}}</h1>
<p class="description">{{atelier.description_longue}}</p>


<!-- <div class="preview-commentaires">
    <div class="commentaire">
        <p>date : 12/12/2024</p>
        <p>c'etait super mes deux enfants on adoré et son revenus avec des étoiles pleins les yeux !</p>
    </div>

    <div class="commentaire">
        <p>date : 15/11/2024</p>
        <p>à refaire absolument </p>
    </div>
</div> -->

<div class="agenda">
    <h2>retrouvez les prochaines session ce cet ateliers !</h2>

    @if(evenements && evenements.length > 0) {
    <p>liste des ateliers prevus</p>
    <div class="evenements-wrapper">
        @for (evenement of evenements; track $index) {
        <app-carte-agenda [evenement]="evenement"></app-carte-agenda>
        }
    </div>
    }
    @else {
    <p>il n'y a pas de dates prevus pour cet atelier prochainement. On peux en cplacez une si vous voulez</p>
    }

    <h2>Je veux faire cet atelier !</h2>
</div>



}